/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable default-case */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import { isPlainObject } from 'lodash';
import qs from 'query-string';
import { SessionStorageKey, ErrorCode } from '@constants';

let baseURL = `https://${process.env.API_HOSTNAME}`;
const inital = {
  method: 'GET',
  params: null,
  body: null,
  headers: {},
  cache: 'no-cache',
  credentials: 'include',
  responseType: 'JSON',
};

// switch (env) {
//   case 'local':
//   case 'dev':
//     baseURL = 'https://api-test.seel.com';
//     break;
//   case 'prod':
//     baseURL = 'https://api.seel.com';
//     break;
//   default:
//     baseURL = 'https://api.seel.com';
//     break;
// }

const basePath = '/gateway/merchant-service/api/open-platform/';

export default function request(url, config) {
  if (typeof url !== 'string') throw new TypeError('url must be required and of string type');
  if (!isPlainObject(config)) config = {};
  const { path = basePath, ...rest } = config;
  config = {
    ...inital,
    ...rest,
  };

  let {
    method,
    params,
    body,
    headers,
    responseType,
  } = config;

  if (!/^http(s?):\/\//i.test(url)) url = baseURL + path + url;
  if (params != null) {
    if (isPlainObject(params)) params = qs.stringify(params);
    url += `${url.includes('?') ? '&' : '?'}${params}`;
  }

  const userId = sessionStorage.getItem(SessionStorageKey.UserId);
  const userIdHeader = userId ? { 'x-user-id': userId } : {};
  config.headers = {
    'x-request-id': `op_${Date.now()}`,
    ...userIdHeader,
    ...headers,
  };

  if (isPlainObject(body)) {
    body = JSON.stringify(body);
    config.headers = {
      'Content-Type': 'application/json',
      ...config.headers,
    };
  }

  if (/^(POST|PUT|PATCH)$/i.test(method) && body != null) config.body = body;
  const { handleSessionExpired, ...restConfig } = config || {};

  // 发送请求
  return fetch(url, restConfig).then(async (response) => {
    const {
      status,
    } = response;

    if (status === ErrorCode.Expired) {
      // 处理登录态失效情况
      handleSessionExpired?.(status);
    }

    // 只要状态码是以2或者3开始的，才是真正的获取成功
    if (status >= 200 && status < 400) {
      let result;

      switch (responseType.toUpperCase()) {
        case 'JSON':
          result = await response.json();
          break;
        case 'TEXT':
          result = await response.text();
          break;
        case 'BLOB':
          result = await response.blob();
          break;
        case 'ARRAYBUFFER':
          result = await response.arrayBuffer();
          break;
      }

      return Promise.resolve(result);
    }

    return Promise.reject({
      originResponse: response,
      originRequest: { url, ...config },
    });
  });
}

export const queryUserStatus = async () => {
  const res = await request('user-status');
  const {
    code, message,
    data: {
      login, onBoardingProcess, registerEmail, payment,
    },
  } = res || {};
  if (code === 0) {
    return Promise.resolve({
      login, stage: onBoardingProcess, email: registerEmail, payment,
    });
  }
  return Promise.reject({ code, message, data: res.data });
};
